var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M3 18L7.5 8 12 18",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M4.5 15H10M16 14.5v1a2.5 2.5 0 005 0v-1a2.5 2.5 0 00-5 0z",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("circle", { attrs: { cx: "17", cy: "9", r: "1", fill: "#2C3143" } }),
      _c("circle", { attrs: { cx: "20", cy: "9", r: "1", fill: "#2C3143" } }),
      _c("circle", { attrs: { cx: "6", cy: "5", r: "1", fill: "#2C3143" } }),
      _c("circle", { attrs: { cx: "9", cy: "5", r: "1", fill: "#2C3143" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }